<div *ngIf="data">
  <div class="row" style="border-bottom: 2px solid #ccc;">
    <div class="col-sm-11 movable">
      <h3
        class="head"
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
      >
      TAP {{ data.mode | uppercase }} 
      </h3>
    </div>
    

    <div class="col-sm-1">
      <button
        type="button"
        class="btn btn-dark btn-circle btn-xl"
        [mat-dialog-close]="true"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </div>
  <form [formGroup]="addOrEditform">
    <div class="successMessage alert-dismissible">
      <div *ngIf="warningMessage" class="alert alert-warning" role="alert" style="white-space: pre-line;">
        {{ warningMessage }}
        <button
          type="button"
          class="btn-close"
          (click)="removeMessage()"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>
    
  
      <div *ngIf="successMessage" class="alert alert-success" role="alert">
      {{ successMessage }}
      <button
        type="button"
        class="btn-close"
        (click)="removeMessage()"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="drpchildctrl">
          <!-- <span class="v1"></span> -->
          <label required class="searchLable">DOCK</label>
          <input
            formControlName="dock"
            class="key"
            type="text"
            placeholder="--Type--"
            readonly
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="drpchildctrl">
          <!-- <span class="v1"></span> -->
          <label required class="searchLable">CONTAINER</label>
          <input
            formControlName="container"
            class="key"
            type="text"
            placeholder="--Type--"
            readonly
          />
        </div>
      </div>
      
      <div class="col-md-6">
        <div class="drpchildctrl">
          <!-- <span class="v1"></span> -->
          <label required class="searchLable">KANBAN</label>
          <input
            formControlName="kanban"
            class="key"
            type="text"
            placeholder="--Type--"
            readonly
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="drpchildctrl">
          <!-- <span class="v1"></span> -->
          <label required class="searchLable">MODULE</label>
          <input
            formControlName="moduleNumber"
            class="key"
            type="text"
            placeholder="--Type--"
            readonly
          />
        </div>
      </div>
      <!-- <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">DESCRIPTION</label>
          <input
            formControlName="shiftNumber"
            class="key"
            type="text"
            placeholder="--Type--"
            readonly
          />
        </div>
      </div> -->
      <!-- <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">NO. OF LOTS</label>
          <input
            formControlName="noOfLots"
            class="key"
            type="text"
            placeholder="--Type--"
            readonly
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">NO. OF PIECES</label>
          <input formControlName="noOfPieces" class="key" type="text" placeholder="--Type--" readonly
          />
          <ng-container *ngIf="addOrEdit.tapQuantity.errors && submitted">
                <small *ngIf="addOrEdit.tapQuantity.errors?.required">
                  Tap Quantity is required
                </small>
                
              </ng-container>
        </div>
      </div> -->
      <!-- <div class="col-md-12">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">TAPPED VALUES </label>
          <textarea id="comments" name="comments" rows="4" cols="80" readonly class="textareaColour"></textarea>
        </div>
      </div> -->
      <!-- <div class="col-md-6">
        <div class="drpchildctrl">
        </div>
      </div> -->
      <!-- <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">TAPPED FROM CONTAINER</label>

          <p-dropdown
            id="selSupplier"
            [filter]="true"
            [options]="data.dockList"
            [virtualScroll]="true" 
            [itemSize]="25"
            [showTransitionOptions]="'0ms'" 
            placeholder="Select" 
            formControlName="dock"
            optionLabel="dock" 
            optionValue="dock"
            [resetFilterOnHide]="true"
            [hideTransitionOptions]="'0ms'" 
            autoWidth="true" 
            [style]="{ width: '100%' }"
            scrollHeight="180px">
          >
          </p-dropdown>
        </div>
      </div> -->
      <div class="col-md-6 col-lg-6" >
        <div class="drpchildctrl" style="width: 100%">
          <!-- <span class="v1"></span> -->
          <label class="searchLable">STOCKING DATE</label>
          <input
            class="key"
            type="date"
            [min]="minDate"
            autoWidth="false"
            formControlName="stockingDate"
            (keydown)="onKeyPress($event)"
            maxlength="10"
            placeholder="--Type--"
            ng-required="true"
          />
          <ng-container *ngIf="addOrEdit.stockingDate.errors && submitted">
            <small *ngIf="addOrEdit.stockingDate.errors?.required">
              Stocking Date is required.
            </small>
            
          </ng-container>
        </div>
      </div>
      <!-- <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">TAPPED FROM MODULE/MANIFEST</label>
          
          <p-dropdown
            id="selSupplier"
            [filter]="true"
            [options]="dayWeeks"
            [virtualScroll]="true" 
            [itemSize]="25"
            [showTransitionOptions]="'0ms'" 
            placeholder="Select" 
            formControlName="dayWeek"
            optionLabel="value" 
            optionValue="value"
            [resetFilterOnHide]="false"
            [hideTransitionOptions]="'0ms'" 
            autoWidth="true" 
            [style]="{ width: '100%' }"
            appendTo="body"
            scrollHeight="100px">
          >
          </p-dropdown>
        </div>
      </div> -->
      <div class="col-md-6">
        <div class="drpchildctrl" >
        <!-- <span class="v1"></span> -->
        <label class="searchLable">STOCKING TIME</label>
        <div>
          <select formControlName="stockingHoursHH" id="stockingHoursHH">
            <option value="" disabled selected>HH</option>
            <option *ngFor="let a of hoursArray; let index = index" [value]="index">
              {{ formatNumber(index) }}
            </option>
          </select>
          :
          <select formControlName="stockingMintuesMM" id="stockingMintuesMM">
            <option value="" disabled selected>mm</option>
            <option *ngFor="let a of mintuesArray; let index = index" [value]="index">
              {{ formatNumber(index) }}
            </option>
          </select>
        </div>
        <div>
          <!-- <ng-container *ngIf="addOrEdit.stockingHoursHH.errors && submitted">
            <small *ngIf="addOrEdit.stockingHoursHH.errors?.required">
              Stocking  Time (hour) is required.
            </small>
          </ng-container><br>
          <ng-container *ngIf="addOrEdit.stockingMintuesMM.errors && submitted">
            <small *ngIf="addOrEdit.stockingMintuesMM.errors?.required">
              Stocking  Time (minute) is required.
            </small>
          </ng-container> -->
        </div>
        </div>
      </div>
      <!-- <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">TAP QUANTITY (IN PIECES)</label>
          <input
            formControlName="tapQuantity"
            class="key"
            type="text"
            placeholder="--Type--"
          />
          <ng-container *ngIf="addOrEdit.tapQuantity.errors && submitted">
            <small *ngIf="addOrEdit.tapQuantity.errors?.required">
              Tap Quantity is required
            </small>
            
          </ng-container>
        </div>
      </div> -->
    </div>
    <ng-container *ngIf="errorMessage1">
      <p style="color: red ;">{{ errorMessage1 }}</p>
    </ng-container>
  </form>
 
  <div class="text-right" style="margin-top: 20px" *ngIf="showDownloadUploadButtons">
    
    <button *ngIf="accessEdit" class="review_btn" mat-button (click)="callRespectiveFunction()">
      Save
    </button>

    <!-- <button *ngIf="noSchedule" class="cancel_btn" mat-button (click)="callRespectiveFunction2()">
      Tap Now
    </button>
 -->
    <button class="cancel_btn" mat-button mat-dialog-close="cancel">
      Cancel
    </button>
  </div>
  <div class="text-left" style="margin-top: 20px; display: flex; justify-content: flex-start;" *ngIf="showDownloadUploadButtons">
    <button *ngIf="accessEdit"  class="review_btn" mat-button (click)="callRespectiveFunction2()">
      Tap Now
    </button> 
  </div>
</div>
